function LearningCurve(config) {
    this.activityTitle = '';
    this.activityDescription = '';
    this.bookId = '';
    this.ebookRefDescription = '';
    this.toolInfo = null;

    this.topics = []; // array of Topic objects available to students
    this.allTopics = []; // all topics in activity regardless of instructor topic exclusion
    this.questions = []; // array of Question objects [MC_Question|SC_Question|FB_Question]

    this.score = new Score();

    // place to move the true quiz and topic performance if we're performing a retake
    this.finalScore = null;

    this.config = config;

    // data received via ARGA
    this.studentData = {
        user_rights : '1_student',  // [1_student|3_instructor]
        user_id : 'unknown',
        activity_questions_received : 0,
        user_due_date : '',
        due_date_has_passed : 0,    // [0|1]
        // instructor only properties
        participating_students : 0, // count of students who've logged in to the activity
        started_students : 0,       // count of students who've scored more than 0 points
        completed_students : 0,     // count of students who've completed the activity
        user_id_array : [],
        user_email_array : [],
        user_name_array : [],
        user_rights_array : [],
        user_due_date_array : [],
        user_due_date_has_passed_array : [],
        user_grade_array : [],
        user_activity_scores : [],
        user_questions_received : []
    };
}

function Score() {
    this.curCard = null; // Question object
    this.scoreTarget = 0;
    this.activityScore = 0;
    this.activityGrade = 0;

    this.topicOrder = []; // order topic questions should be shown

    // point reduction factor -- prevention for cheating
    this.initialPointsReductionFactor = 1;
    this.initialPointsReductionFactorMin = .1;

    this.questionStartTime = null;
    this.reductionsSinceLastWarning = 0;

    // minimum time we expect the student to consider each question
    // used to warn the student to slow down
    this.minQuestionConsiderationTime = 5000;

    // scoring related messages to be displayed to the end user
    this.messageToUser;

    // strings to use after a question is completed
    this.correctFeedback = ['Yes!', 'Nice job!', 'Great!', 'Exactly!'];
    this.incorrectFeedback = ['Sorry!'];

    // New hint object
    this.hint = null;

    this.testModeCardCounter = -1;
}


function Topic(label) {
    this.topicId = -1;
    this.label = label;
    // establish array for question results and question levels
    this.questionResults = [];
    this.questionLevels = [];
    //MS 3/19/2013 : PP-2883( Adding new array for valid level because the level_count array contains the missing level also)
    this.allLevel = [];

    this.difficulties = [];
    this.idles = [];

    this.assets = []; // t_item assets that go with the topic
    this.ebookSections = []; // ebook sections that go with the topic
    this.studyPlan = []; // array of StudyPlanItem objects

    this.levelCount = []; // number of questions in each level
    this.nextLevel = 1; // next level to be tested -- by default start at 1
    this.totalPointsEarned = 0;
    this.totalPointsAvailable = 0;
    this.questionsReceived = 0;
    this.totalQuestions = 0;

    // instructor specific properties
    this.pa_arr = [];
    this.pe_arr = [];
}

function StudyPlanItem() {
    this.displayValue = '';
    this.bookId = null;
    this.itemType = null;
    this.pageId = null;
}

function Question() {
    this.questionIndex = -1;   // display index for the question; will be supplied on initialization
    this.questionType = null;
    this.questionText = '';
    this.feedback = '';
    this.feedbackCorrect = '';
    this.feedbackIncorrect = '';
    // assigned in checkAnswer from Score.correctFeedback or Score.incorrectFeedback
    // default values can be overridden by WHOOPS_STRING in the activity file
    this.feedbackIntro = '';
    this.grade = -1;			// percentage; -1 means not assigned
    this.topic = null;          // Topic object

    // scoring info
    this.score = 0;
    this.primary = false;
    this.completed = false;
    this.givenUp = false;
    this.numHelps = 0;
    this.firstAutoHint = false;
    this.takenContentHint = false;
    this.answeredWrong = 0;     // count of wrong answers given
    this.timesCorrect = 0;
    this.timesTested = 0;

    this.pointsAvailable = 0;
    this.originalPointsAvailable = 0;
    this.pointsAchieved = 0;  // points achieved after scoring a correct answer

    // properties beginning with underscore in activity description file
    this.meta = {
        never_scramble: false
    };

    // OBSOLETE, marked for deletion
    // joliver: these properties exist in legacy LC, but appear to have been deprecated
    this.points_possible = 1;	// default 1 point per question
    this.question_number = '';  // question number to be used for display purposes
    this.question_data = '';	// "question data" received back from ARGA
    this.question_source = '';
    this.question_source_obj = null;
    this.shuffleAnswer = false;
}


MC_Question.prototype = Object.create(Question.prototype);
MC_Question.prototype.constructor = MC_Question;

// Multiple Choice
function MC_Question() {
    Question.call(this);
    // define and set defaults for variables specific to this question type
    this.choices = [];
    this.choices_fb = [];  // feedback for each choice
    this.choice_ids = [];
    this.correctAnswerIndex = null;
    this.userAnswerIndex = null;
    this.answered = [];    // answers given by user
}
MC_Question.prototype.choicesLeft = function choicesLeft() {
    return this.choices.length - this.answeredWrong;
};

// sentence click has same structure as multiple choice
SC_Question.prototype = Object.create(MC_Question.prototype);
SC_Question.prototype.constructor = SC_Question;
function SC_Question() {
    MC_Question.call(this);
    this.questionTextForDisplay = '';
}


FB_Question.prototype = Object.create(Question.prototype);
FB_Question.prototype.constructor = FB_Question;
function FB_Question() {
    Question.call(this);
    this.answerType = ''; // [string|numeric]
    this.maxHelps = 1;
    this.choice_phrases = [];
    this.answers = []; // array of possible answers
    this.testTerm = ''; // testTerm is the first answer
    this.userAnswer = null;
}
FB_Question.prototype.choicesLeft = function choicesLeft() {
    return 2; // always more than one choice left for FB questions
};

exports.LearningCurve = LearningCurve;
exports.Topic = Topic;
exports.StudyPlanItem = StudyPlanItem;
exports.MC_Question = MC_Question;
exports.SC_Question = SC_Question;
exports.FB_Question = FB_Question;
